// Crosshair plugin with nearest point detection
export const crosshairPlugin = {
	id: "crosshair",
	afterInit: (chart) => {
		chart.crosshair = {
			x: 0,
			y: 0,
			draw: false,
		};
	},
	afterEvent: (chart, args) => {
		const { inChartArea } = args;
		const { type, x, y } = args.event;

		chart.crosshair = {
			x,
			y,
			draw: inChartArea,
		};

		if (type === "mouseout") {
			chart.crosshair.draw = false;
		}

		chart.draw();
	},
	afterDraw: (chart) => {
		const { ctx } = chart;
		const { crosshair } = chart;

		if (!crosshair?.draw) return;

		const { x, y } = crosshair;
		const topY = chart.scales.y.top;
		const bottomY = chart.scales.y.bottom;
		const leftX = chart.scales.x.left;
		const rightX = chart.scales.x.right;

		// Draw crosshair lines
		ctx.save();
		ctx.setLineDash([2, 2]);
		ctx.lineWidth = 0.75;
		ctx.strokeStyle = "rgba(255, 255, 255, 0.3)";

		// Vertical line
		ctx.beginPath();
		ctx.moveTo(x, topY);
		ctx.lineTo(x, bottomY);
		ctx.stroke();

		// Horizontal line
		ctx.beginPath();
		ctx.moveTo(leftX, y);
		ctx.lineTo(rightX, y);
		ctx.stroke();

		ctx.restore();

		// Find the nearest point based on X position (vertical line)
		let nearestPoint = null;
		let minDistance = Infinity;

		chart.data.datasets.forEach((_dataset, datasetIndex) => {
			const meta = chart.getDatasetMeta(datasetIndex);
			meta.data.forEach((point) => {
				const distance = Math.abs(point.x - x);
				if (distance < minDistance) {
					minDistance = distance;
					nearestPoint = point;
				}
			});
		});

		// Draw only the nearest point
		if (nearestPoint) {
			ctx.save();
			ctx.beginPath();
			ctx.arc(nearestPoint["x"], nearestPoint["y"], 2, 0, 2 * Math.PI);
			ctx.fillStyle = "#1E5DBF";
			ctx.fill();
			ctx.strokeStyle = "rgba(30, 93, 191,0.8)";
			ctx.lineWidth = 3;
			ctx.stroke();
			ctx.restore();
		}
	},
};

export const createGradient = (ctx, chartArea) => {
	const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
	gradient.addColorStop(0, "rgba(31, 96, 196, 0.8)");
	gradient.addColorStop(0.5, "rgba(31, 96, 196, 0.4)");
	gradient.addColorStop(1, "rgba(31, 96, 196, 0.05)");
	return gradient;
};
